import { useContext } from "react";
import { AppContext } from "../App";
import { MdMenu } from "react-icons/md";
import logo from "../assets/logo.png";
import logo_worded from "../assets/logo_worded.png";
import { IoMdCall } from "react-icons/io";

export default function TopBar() {
  const appContext = useContext(AppContext);

  function goTo(item) {
    appContext.navTo({ item });
  }

  const navItems = [
    { label: "Home", key: "home" },
    { label: "About Us", key: "about_us" },
    { label: "Products & Services", key: "services" },
  ];

  return (
    <div className="TopBar topbar-modern px-0">
      <div className="body topbar-modern-body px-0">
        <div className="container d-flex align-items-center justify-content-between h-100 px-2">
          <div className="topbar-brand d-flex align-items-center">
            <img
              src={logo}
              alt="NCCL logo"
              className="mDesktopOnly p-2 rounded"
              style={{ height: 70, width: "auto", cursor: "pointer", background:"rgba(0,0,0,0)" }}
              onClick={() => goTo("home")}
            />
           
            <img
              src={logo}
              alt="NCCL logo"
              className="mMobileOnly p-2 rounded"
              style={{ height: "65px", width: "auto", cursor: "pointer", background:"rgba(0,0,0,0)" }}
              onClick={() => goTo("home")}
            />
          </div>

          <div className="topbar-modern-nav-wrap mDesktopOnly">
            <div className="topbar-modern-nav">
              {navItems.map((item) => (
                <button
                  key={item.key}
                  className={`topbar-modern-link ${appContext.navItem === item.key ? "active" : ""}`}
                  onClick={() => goTo(item.key)}
                >
                  {item.label}
                </button>
              ))}
            </div>

          </div>

          <div className="topbar-mobile-actions mMobileOnly d-flex align-items-center">
            <button
              className="btn btn-sm btn-light btn-rounded me-2 d-flex align-items-center gap-2"
              onClick={() => goTo("contact_us")}
              aria-label="Contact us"
            >
              <IoMdCall size={24} /><span className="fs-6 mDesktopOnly">Contact Us</span>
            </button>

            <button
              className="topbar-modern-menu-btn mMobileOnly"
              onClick={appContext.openSideBar}
              aria-label="Open menu"
            >
              <MdMenu size={30} />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
